define('common/string',["require", "exports"], function (require, exports) {
    "use strict";
    var String;
    (function (String) {
        function contains(source, symbol) {
            if (source == null || symbol == null)
                return false;
            return source.indexOf(symbol) > -1;
        }
        String.contains = contains;
        function startsWith(sourceString, startWith) {
            var result;
            if (sourceString != null && startWith != null && sourceString.length >= startWith.length) {
                if (sourceString.indexOf(startWith) == 0) {
                    result = true;
                }
                else {
                    result = false;
                }
            }
            else {
                result = false;
            }
            return result;
        }
        String.startsWith = startsWith;
        function endsWith(sourceString, endWith) {
            var result;
            if (sourceString != null && endWith != null && sourceString.length >= endWith.length) {
                var startIndexOfPossibleFound = sourceString.length - endWith.length;
                if (sourceString.lastIndexOf(endWith) == startIndexOfPossibleFound) {
                    result = true;
                }
                else {
                    result = false;
                }
            }
            else {
                result = false;
            }
            return result;
        }
        String.endsWith = endsWith;
        function isNullOrEmpty(sourceString) {
            if (sourceString == null || sourceString == undefined || sourceString.length === 0) {
                return true;
            }
            return false;
        }
        String.isNullOrEmpty = isNullOrEmpty;
        function htmlEscape(value) {
            return value
                .replace(/&/g, '')
                .replace(/%/g, '')
                .replace(/#/g, '')
                .replace(/:/g, '')
                .replace(/"/g, '')
                .replace(/'/g, '')
                .replace(/</g, '')
                .replace(/\+/g, '')
                .replace(/>/g, '');
        }
        String.htmlEscape = htmlEscape;
        function removeEmptyCharactersFromBeginningOfString(value) {
            if (String.isNullOrEmpty(value))
                return "";
            while (value.indexOf(" ") === 0) {
                value = value.substring(1, value.length);
            }
            return value;
        }
        String.removeEmptyCharactersFromBeginningOfString = removeEmptyCharactersFromBeginningOfString;
        function getAnyCharactersButExcludeExpressions(value, expressions) {
            if (expressions == null || expressions.length == 0)
                return "";
            expressions.forEach(function (expression) {
                if (expression.test(value)) {
                    var res = expression.exec(value)[0];
                    value = value.replace(res, "");
                }
            });
            return value;
        }
        String.getAnyCharactersButExcludeExpressions = getAnyCharactersButExcludeExpressions;
        function getValueFromExpression(value, expression) {
            var result = "";
            if (expression.test(value)) {
                result = expression.exec(value)[1];
            }
            return result;
        }
        String.getValueFromExpression = getValueFromExpression;
        function getExtensionFromFileName(name) {
            var fileParts = name.split(".") || "";
            var fileExtension = fileParts[fileParts.length - 1];
            return fileExtension;
        }
        String.getExtensionFromFileName = getExtensionFromFileName;
    })(String || (String = {}));
    return String;
});

